import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useGym } from '../../DataStore/Gym/GymContext';
import ActivityLoader from '../Common/ActivityLoader';
import Notification from '../Common/Notification';

const PopularClasses = () => {

   const { getFrequentClasses, frequentClasses } = useGym();
  
    useEffect(() => {
      getFrequentClasses();
    }, []);
  

 
  return (
    <div className="main-card mb-3 card">
      <div className="card-header card-title">Top Classes
          <div className="btn-actions-pane-right actions-icon-btn">
                <button className='btn-pill btn btn-outline-primary btn-sm'>Manage</button>
            </div>
      </div>

      <div className="card-body overflow-auto" style={{maxHeight: '300px'}}>
        <div className="row">
          {Array.isArray(frequentClasses) && frequentClasses.map((cls) => (
            <div key={cls.id} className="col-12 mb-3">
              <div className="d-flex align-items-center justify-content-between p-3 bg-light rounded shadow-sm">
                <div className="d-flex align-items-center">
                  <i className="fa fa-star text-warning mr-2"></i>
                  <div>
                    <div className="font-weight-bold mb-1">{cls.class_name}</div>
                    <small className="text-muted">{cls.description}</small>
                  </div>
                </div>
                <div
                  style={{
                    minWidth: 38,
                    height: 38,
                    borderRadius: '50%',
                    backgroundColor: '#6c757d',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    lineHeight: '1',          // prevents vertical overflow
                    textAlign: 'center',
                  }}
                >
                  {parseInt(cls.popularity, 10) > 99 ? '99+' : cls.popularity}
                </div>

              </div>
            </div>
          ))}
          {!frequentClasses && <ActivityLoader />}
          {frequentClasses === "404" &&  <Notification message="No class activity found." closable={false} />}
        </div>
      </div>
    </div>
  );
};

export default PopularClasses;
